// export const BASE_URL = "http://localhost:3045/admin/"
// export const IMAGE_URL = "http://localhost:3045/"
export const BASE_URL = "https://pacifricab.sigisolutions.net/admin/"
export const IMAGE_URL = "https://pacifricab.sigisolutions.net/"


// y